export default __webpack_public_path__ + "static/ActaDisplay-ExtraBold-943d44fb4e46c563c7b1a5b6e1d71c95.woff";